import React from 'react';
import { makeProductImageObjects } from '../../../utils/utils';
import { Box } from '@generationtux/component-library';
import styled from 'styled-components';

const ThumbnailWrap = styled(Box)`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
  img:first-child {
    position: relative;
  }
  img[class*='collar'] {
    z-index: 10;
  }
`;

const PreviewLayerThumbnails = ({ product, activeCollection, ...props }) => {
  const productObjects = makeProductImageObjects(product);

  return (
    <ThumbnailWrap className="thumbnail-wrap" {...props}>
      {productObjects.map((layer, index) => {
        const { classStr, url, catalogNumber } = layer;
        return (
          <img
            key={`${url}${catalogNumber}${index}`}
            src={`${url}?fit=crop&crop=fp&width=80&ar=1:1&${layer.thumbnailCrop}`}
            alt={`${catalogNumber}`}
            className={classStr}
          />
        );
      })}
    </ThumbnailWrap>
  );
};

export default PreviewLayerThumbnails;
